<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'CHANGE_REVIEW', pageCode: 'ALL', subPageCode: 'VIEW' }" class="product-details">
    <div class="grid mt-1 details-div border-bottom-1 border-200 mr-0 product-details-header">
        <div class="col-7 md:col-8 details-header-spacing">
            <div class="flex align-items-center p-3">
                <div>
                    <span class="font-semibold review-id">{{ attributeValues?.protocolReviewRequestId}}</span> 
                </div> 
                <div class="header-protocol">{{ attributeValues?.protocolName}}</div>
            </div>
        </div>
        <div appAccessProvider [accessCode]="{ menuCode: 'CHANGE_REVIEW', pageCode: 'ALL', subPageCode: 'STATUS_UPDATE' }" class="col-4 flex align-items-center justify-content-end">
             @if(attributeValues) {
                <app-change-review-status [attributeValues]="attributeValues"></app-change-review-status>
             }
            <button pButton class="edit-btn border-400 whitespace-nowrap view-change-btn text-white ml-3" [label]="editBtnLabel" (click)="redirectToEdit()">
            </button>
        </div>
    </div>
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true" class="vehicle-detail-tab">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg overview"></i>
                <label class="capitalize" translate>product.lbl_overview</label>
            </ng-template>
            @if (attributeValues) {
                <app-overview-details
                    [attributeValues]="attributeValues"
                    [attributeLabels]="attributeLabels"
                    [protocolAttributeData]="protocolAttributeData"
                    [protocolReviewRequestId]="protocolReviewRequestId"
                    [protocolRefID]="protocolRefID"
                    [changeReviewRowData]="currentRow"
                    [entityCode]="entityCode"
                    [changeReviewDetails]="changeReviewDetails"
                ></app-overview-details>
            }
        </p-tabPanel>
    </p-tabView>
</div>